module.exports = __webpack_public_path__ + "img/rj.b9b52213.svg";